module.exports = __webpack_public_path__ + "static/pathology-b7904c44991210c8fb99af7a4a10d1f0.jpg";